import { render, staticRenderFns } from "./userInfoAvartar.vue?vue&type=template&id=16b383ba&scoped=true"
import script from "./userInfoAvartar.vue?vue&type=script&lang=js"
export * from "./userInfoAvartar.vue?vue&type=script&lang=js"
import style0 from "./userInfoAvartar.vue?vue&type=style&index=0&id=16b383ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b383ba",
  null
  
)

export default component.exports